import { render, staticRenderFns } from "./ProductCategoriesDropdown.vue?vue&type=template&id=4555e072&scoped=true"
import script from "./ProductCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoriesDropdown.vue?vue&type=style&index=0&id=4555e072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555e072",
  null
  
)

export default component.exports